import { Component } from 'react'
import { StylewherePage, DefaultHeader, Section, GridData, NotFound } from '../../../components'
import { StwFullBarcodeReader } from '../../../api'
import { __, T } from '../../../shared/i18n'
import { ExtendRouteComponentProps } from '../../../types'
import BarcodeReaders from '../../../api/BarcodeReaders'
import { BARCODE_READERS_DATA } from '../../../config/Pages/Devices/BarcodeReaders'
import { getMultipleTitle, getBackURL, getFragmentObject } from '../../../shared/utils'

interface State {
  barcodeReader: StwFullBarcodeReader | undefined
  loader: boolean
}

class BarcodeReaderDetail extends Component<ExtendRouteComponentProps, State> {
  constructor(props) {
    super(props)
    this.state = {
      barcodeReader: undefined,
      loader: true,
    }
  }

  componentDidMount = async () => {
    let barcodeReader
    if (this.props.match) {
      const barcodeReaderId = this.props.match.params.barcodeReaderId
      if (barcodeReaderId) {
        barcodeReader = await BarcodeReaders.getFullBarcodeReader(barcodeReaderId).then((res) => res)
      }
    }

    this.setState({
      barcodeReader,
      loader: false,
    })
  }

  render() {
    const { barcodeReader, loader } = this.state
    const { breadcrumbs, queryString } = this.props
    const fragment = getFragmentObject(barcodeReader, 'code')
    return (
      <StylewherePage {...this.props} noOverflow fragment={fragment}>
        <DefaultHeader
          backPath={getBackURL(queryString, breadcrumbs)}
          multipleTitle={getMultipleTitle(barcodeReader)}
          title={__(T.misc.not_found)}
          skeleton={{ active: loader, options: { multiple: true } }}
        />
        <Section customClass={`stw-section-page paged-header ${barcodeReader || loader ? 'scroll transparent' : ''}`}>
          {barcodeReader || loader ? (
            <GridData fields={BARCODE_READERS_DATA} record={barcodeReader || {}} skeleton={loader} />
          ) : (
            <NotFound fullheight title={__(T.misc.noRecordFoundTitle)} />
          )}
        </Section>
      </StylewherePage>
    )
  }
}

export default BarcodeReaderDetail
